<h2 class="pb-s">
  Module im Überblick
</h2>
<p>
  <strong>Für jeden Bedarf das passende Modul.</strong> Bei Interesse oder Rückfragen sprechen Sie gerne Ihre Gebietsverkaufsleitung an.
</p>

<div class="content mt-l table-cms1">
  <div class="row">
    <div class="col-md-6 col-xl-3">
      <table class="table">
        <tr class="table-info text-center text-l">
          <th class=" text-l">Modul 1</th>
        </tr>
        <tr>
          <td>Vereinbarung Kooperationsumsatz & Umsatz PHOENIX</td>
        </tr>
      </table>
    </div>
    <div class="col-md-6 col-xl-3">
      <table class="table">
        <tr class="table-success text-center text-l">
          <th class=" text-l">Modul 2</th>
        </tr>
        <tr>
          <td><strong>Alle Modul 1-Vorteile und zusätzlich:</strong></td>
        </tr>
        <tr>
          <td>Modul 2 NRX Marketing</td>
        </tr>
        <tr>
          <td>Umsetzung Marketingpaket zur Endkundenaktivierung</td>
        </tr>
      </table>
    </div>
    <div class="col-md-6 col-xl-3">
      <table class="table">
        <tr class="table-warning text-center text-l">
          <th class=" text-l">Modul 3</th>
        </tr>
        <tr>
          <td><strong>Alle Modul 2-Vorteile und zusätzlich:</strong></td>
        </tr>
        <tr>
          <td>Modul 3 NRX LINDA Premium</td>
        </tr>
        <tr>
          <td>Teilnahme an <ul class="pl-m"> <li>LINDA Premium</li><li>LINDA Kampagnen</li></ul></td>
        </tr>
        <tr>
          <td>Voraussetzung:<ul class="pl-m"> <li>Abschluss und Erfüllung Modul 1 & 2</li><li>
            Vertrag MVDA notwendig</li></ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
